import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Favorite"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.8375 4.49999C17.9406 4.49906 18.9976 4.9424 19.77 5.72999C21.4092 7.39411 21.4092 10.0659 19.77 11.73L12 19.5975L4.22997 11.73C2.59076 10.0659 2.59076 7.39411 4.22997 5.72999C5.00278 4.943 6.05948 4.49966 7.16247 4.49966C8.26546 4.49966 9.32216 4.943 10.095 5.72999L12 7.67999L13.8975 5.74499C14.6677 4.94785 15.729 4.4984 16.8375 4.49999ZM16.8376 3C15.331 2.99873 13.8874 3.60428 12.8326 4.68L12.0001 5.52L11.1676 4.68C10.1115 3.60629 8.66859 3.00157 7.16258 3.00157C5.65656 3.00157 4.21361 3.60629 3.15758 4.68C0.944871 6.9325 0.944871 10.5425 3.15758 12.795L12.0001 21.75L20.8426 12.795C23.0553 10.5425 23.0553 6.9325 20.8426 4.68C19.7868 3.60571 18.3438 3.00042 16.8376 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Favorite.vue"]]);
